import { buildPdpCanonicalUrl } from "helpers/third-party/sailthru-helpers";
import { useEffect } from "react";
import { useSelector } from "react-redux";

// Sets `window.sailthruConfig` on page load. This config is picked up by
// the sailthru 3rd party script when it loads.
export default function useSailthruConfig() {
  const sailthruCustomerId = useSelector(state => state.publicEnv.sailthruCustomerId);
  const initialUrl = useSelector(state => state.initialUrl);
  const productId = useSelector(state => state.staticProduct.productId);

  useEffect(() => {
    window.sailthruConfig = {
      customerId: sailthruCustomerId,
      url: buildPdpCanonicalUrl(initialUrl, productId),
    };
  }, []);
}
